import cn from 'classnames';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { Button } from '../../../Button';
import { Icon, IconProps } from '../../../Icon/Icon';
import styles from './SideNavbarItem.module.scss';

export interface SideNavbarItemI {
  title: string;
  cancelRedirect: boolean;
  onClick: () => void;
  navigateTo: string;
  icon: IconProps['type'];
  subItems: SideNavbarItemI[];
}

export const SideNavbarItem = ({
  title,
  cancelRedirect,
  onClick = () => {},
  navigateTo = undefined,
  subItems,
  icon,
  isExpanded = true,
}: SideNavbarItemI & { isExpanded: boolean }) => {
  const location = useLocation();
  useEffect(() => {}, []);

  return (
    <Button
      onClick={onClick}
      to={navigateTo}
      className={cn(
        styles.root,
        location.pathname === navigateTo && styles.active
      )}
    >
      <>
        <Icon
          classname={cn(styles.icon, isExpanded && styles.expanded)}
          type={icon}
        />
        <div className={cn(styles.title, isExpanded && styles.expanded)}>
          {title}
        </div>
      </>
    </Button>
  );
};
